import request from '../request'

// MF-67 — Journal categories API (Maestro-managed taxonomy).
export const getCategories = (params = {}) =>
  request.get('/journal/categories', { params }).then((res) => res)

export const getCategory = (categoryId = '') =>
  request.get(`/journal/categories/${categoryId}`).then((res) => res)

export const createCategory = (data = {}) => request.post('/journal/categories', data).then((res) => res)

export const updateCategory = (categoryId = '', data = {}) =>
  request.put(`/journal/categories/${categoryId}`, data).then((res) => res)

export const deleteCategory = (categoryId = '') =>
  request.delete(`/journal/categories/${categoryId}`).then((res) => res)
